import React from 'react';

const PinIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" {...rest}>
      <g clipPath="url(#clip0_8131_5334)">
        <path d="M16.7355 3.33625C16.395 2.99559 15.9431 2.78921 15.4627 2.75504C14.9823 2.72087 14.5057 2.8612 14.1205 3.15025L11.2075 5.33525C9.99738 6.24303 8.57799 6.83115 7.08048 7.04525L4.90348 7.35525C4.17348 7.46025 3.63848 8.24625 3.99048 9.01725C4.32148 9.74025 5.37548 11.6462 8.35048 14.7372L4.17248 18.9152C4.07697 19.0075 4.00078 19.1178 3.94837 19.2398C3.89597 19.3618 3.86838 19.4931 3.86723 19.6258C3.86607 19.7586 3.89137 19.8903 3.94165 20.0132C3.99193 20.1361 4.06619 20.2477 4.16008 20.3416C4.25397 20.4355 4.36563 20.5098 4.48852 20.5601C4.61142 20.6104 4.7431 20.6357 4.87588 20.6345C5.00866 20.6333 5.13988 20.6058 5.26188 20.5533C5.38388 20.5009 5.49423 20.4248 5.58648 20.3292L9.76448 16.1512C12.8555 19.1262 14.7615 20.1802 15.4845 20.5112C16.2545 20.8632 17.0415 20.3282 17.1455 19.5982L17.4565 17.4212C17.6706 15.9237 18.2587 14.5043 19.1665 13.2942L21.3505 10.3812C21.6395 9.99602 21.7799 9.51942 21.7457 9.03902C21.7115 8.55862 21.5051 8.10669 21.1645 7.76625L16.7345 3.33625H16.7355Z" fill="#C3C5CA"/>
      </g>
      <defs>
        <clipPath id="clip0_8131_5334">
          <rect width="24" height="24" fill="white" transform="translate(0 0.5)"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default PinIcon;